import toml from 'toml';

export const parse = toml.parse;

/**
 * The used `toml` package supports parsing only, there is no `stringify` or
 * similar method. Following logic is copied from the `toml-js` package, that
 * can parse/stringify, but its parse logic lacks the error reporting. I did not
 * want to load both packages for bundle size reasons, and the `toml-js` is not
 * written in ESM, so we cannot pick just the `stringify` method from it, so I
 * choose to load the `toml` package for parsing and the `stringify` is
 * hand-picked.
 * @see https://github.com/alexbeletsky/toml-js/blob/fd90ede05f44489307b7d7c0b568954e7f1f4dc5/src/toml.js#L270
 */

const escapeString = (str) => {
  return str
    .replaceAll('\b', '\\b')
    .replaceAll('\t', '\\t')
    .replaceAll('\n', '\\n')
    .replaceAll('\f', '\\f')
    .replaceAll('\r', '\\r')
    .replaceAll('"', '\\"');
};

const isSimpleType = (value) => {
  const type = typeof value;
  const strType = Object.prototype.toString.call(value);
  return (
    type === 'string' ||
    type === 'number' ||
    type === 'boolean' ||
    strType === '[object Date]' ||
    strType === '[object Array]'
  );
};

const dumpObject = (value, context) => {
  context = context || [];
  const type = Object.prototype.toString.call(value);
  if (type === '[object Date]') {
    return value.toISOString();
  } else if (type === '[object Array]') {
    if (value.length === 0) {
      return null;
    }
    let bracket = '[';
    for (let index = 0; index < value.length; ++index) {
      bracket += `${dump(value[index])}, `;
    }
    return `${bracket.substring(0, bracket.length - 2)}]`;
  }

  let result = '',
    simpleProps = '';
  let propertyName;

  for (propertyName in value) {
    if (isSimpleType(value[propertyName])) {
      simpleProps += `${propertyName} = ${dump(value[propertyName])}\n`;
    }
  }

  if (simpleProps) {
    if (context.length > 0) {
      var contextName = context.join('.');
      result += `[${contextName}]\n`;
    }
    result += `${simpleProps}\n`;
  }

  for (propertyName in value) {
    if (!isSimpleType(value[propertyName])) {
      result += dump(value[propertyName], context.concat(propertyName));
    }
  }

  return result;
};

const dump = (value, context) => {
  // eslint-disable-next-line default-case
  switch (typeof value) {
    case 'string':
      return `"${escapeString(value)}"`;
    case 'number':
      return `${value}`;
    case 'boolean':
      return value ? 'true' : 'false';
    case 'object':
      return dumpObject(value, context);
  }
};

export const stringify = (value) => dump(value).trimEnd();
